import styled from 'styled-components';

export const Container = styled.div`
  form {
    width: 100%;
    p {
      font-size: 18px;
      line-height: 24px;
      color: #2a2a2a;
      font-weight: 400;
      word-wrap: break-word;
      word-break: break-word;
    }

    .buttonImport {
      font-size: 16px;
      line-height: 24px;
      color: #2a2a2a;
      word-wrap: break-word;
      word-break: break-word;
      font-weight: 400;
      margin-top: 30px;
      width: 200px;
      margin-left: auto;
      div {
        display: flex;
        flex-direction: column;
        justify-self: flex-end;
        align-items: flex-end;
      }

      button {
        width: 200px;
      }
    }
    .erro {
      width: 101%;
      margin-top: 10px;
      overflow-y: scroll;
      max-height: 200px;
      ::-webkit-scrollbar-track {
        background: transparent;
      }
      ::-webkit-scrollbar {
        background-color: transparent;
        width: 12px;
        height: 10px;
      }
      ::-webkit-scrollbar-thumb {
        background-color: #949494;
        height: 50px;
        border-radius: 10px;
      }
    }
    .errosLength {
      position: absolute;
      margin-top: -30px;
    }
    .descriptionErro {
      background: #ff00008f;
      color: var(--white);
      padding: 10px;
      font-size: 1.15rem;
      border-radius: 5px;
      margin-bottom: 5px;
      margin-right: 5px;
    }
  }
  .buttonsContainer {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 20px;

    .cancelar {
      height: 40px;
      width: inherit;
      margin-right: 15px;
      color: var(--orange);
      background-color: transparent;
      border: 2px solid var(--orange);

      &:hover {
        color: var(--white);
        background-color: var(--orange);
      }
    }

    .enviar {
      height: 40px;
      width: inherit;
      color: var(--white);
      background-color: var(--orange);
      border: 2px solid var(--orange);

      &:hover {
        color: var(--orange);
        background-color: var(--white);
      }
    }
  }
`;
